var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.835,
    height: 23.674,
    viewBox: "0 0 20.835 23.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.913,23.674,10.862,7.682a1.572,1.572,0,0,1,0-2.225h0L16.319,0l3.788,3.764a1.583,1.583,0,0,1,.012,2.225L20.106,6,18.769,7.327l5.788,5.765,2.427-2.427,3.788,3.764a1.583,1.583,0,0,1,.012,2.225l-.012.012-1.752,1.74L28.2,17.59l1.752-1.74a.414.414,0,0,0,0-.592h0l-2.971-2.947-2.427,2.427-7.434-7.41L19.29,5.185a.414.414,0,0,0,0-.592h0L16.319,1.634l-4.64,4.628a.414.414,0,0,0,0,.592h0L27.718,22.846Z",
    transform: "translate(-10.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPhone);
export default __webpack_public_path__ + "static/media/ico_phone.cd43c387b345ba09f21ba5bbe1a74091.svg";
export { ForwardRef as ReactComponent };